import React from "react";
import { Button } from "../../../../../design/button";
import { Field, Label } from "../../../../../design/fieldset";
import OnboardingContainer from "../../../components/OnboardingContainer";
import { Select } from "../../../../../design/select";
import { SpouseAwarenessStatus } from "../../../../../models/SpouseAwarenessStatus";
import { Intake } from "../../../../../models/Intake";

const OnboardingSpouseAwarenessStep: React.FC<{
  formData: Omit<
    Intake,
    "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy" | "status"
  >;
  setFormData: React.Dispatch<
    React.SetStateAction<
      Omit<
        Intake,
        "_id" | "createdAt" | "updatedAt" | "createdBy" | "updatedBy" | "status"
      >
    >
  >;
  onBack: () => void;
  onStepComplete: () => void;
}> = ({ onBack, onStepComplete, formData, setFormData }) => {
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onStepComplete();
  };

  return (
    <OnboardingContainer title={"Spouse Awareness"}>
      <>
        <p className="mb-6 text-gray-700">
          Is your spouse aware that you are planning to file for divorce?
        </p>
        <form onSubmit={handleSubmit} className="space-y-6">
          <Field>
            <Label>Does your spouse know?</Label>
            <Select
              value={formData.spouseAwarenessStatus ?? ""}
              onChange={(e) => {
                setFormData({
                  ...formData,
                  spouseAwarenessStatus: e.target
                    .value as SpouseAwarenessStatus,
                });
              }}
            >
              <option value="" disabled>
                Select an option
              </option>
              <option value="aware">Yes</option>
              <option value="unaware">No</option>
              <option value="unsure">Not sure</option>
            </Select>
          </Field>
          <Button
            type="submit"
            className="w-full"
            disabled={!formData.spouseAwarenessStatus}
          >
            Continue
          </Button>
        </form>
      </>
    </OnboardingContainer>
  );
};

export default OnboardingSpouseAwarenessStep;
